import { useMutation, useQueryClient } from 'react-query';

import { EmployerCostSettingsRequest } from '../types';

import {
  createEmployerCostSettings,
  editEmployerCostSettings
} from 'RestAPIs/admin';

import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

interface Params {
  isCopy: boolean;
  data: EmployerCostSettingsRequest;
}

export const useSave = (handleClose) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ isCopy, data }: Params) =>
      isCopy
        ? createEmployerCostSettings(data)
        : editEmployerCostSettings(data),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['EmployerCostSettings', 'list']);
        handleClose();
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};
